import * as React from 'react';
const SvgElixiaSmall = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={93}
    height={21}
    fill="currentColor"
  >
    <path d="M9.94 4.28 8.902 7.803h6.483l-1.21 4.363h-6.57L6.483 16.11h8.816l-1.296 4.363H0L5.964 0h14.002l-1.297 4.363H9.94zM32.585 16.195l-1.297 4.363H17.805L23.769.084h5.186l-4.668 16.195h8.298zM40.536 0h5.186l-5.964 20.474h-5.186zM58.514 10.489l3.544 9.985h-5.273l-2.16-6.461-5.618 6.461h-5.964l9.594-10.657L49.093 0h5.272l2.161 6.293L61.971 0h5.964zM71.047 0h5.185L70.27 20.474h-5.186zM93 0v20.474h-4.58v-4.28h-7.002l-2.42 4.28h-5.532L86 0zm-4.58 11.831V3.86l-4.582 7.971z" />
  </svg>
);
export default SvgElixiaSmall;
